import React, {PureComponent, Fragment} from 'react';
import Hammer from 'react-hammerjs';
import {ROUTES} from '../../routes';
import TranslatedText from '../../atoms/TranslatedText';

export default class TruBridgeTecnology extends PureComponent {
    render() {
        const {
            style,
            currentType,
            peoples,
            bullets,
            history,
            swipe,
            state,
        } = this.props;

        let bg = {
            backgroundImage: `url(${currentType.sections[1].image})`,
        };
        let contentBottom;

        if (state === 'tecnology1') {
            contentBottom = (
                <Fragment>
                    <div className="TruBridgeBottom">
                        <div className="TruBridgePeoples">{peoples}</div>
                        <div className="TruBridge-swipe-indicator">
                            <div className="bullets">{bullets}</div>
                        </div>
                    </div>
                    <div className="TruBridge-image" />
                    <button
                        onClick={() => history.push(ROUTES.TRUBRIDGE_SIZING)}
                        className="TruBridge-slide-next">
                        <span>Next</span>
                    </button>
                </Fragment>
            );
        }

        if (state === 'tecnology2') {
            contentBottom = (
                <Fragment>
                    <div className="TruBridgeBottom">
                        <div className="TruBridge-swipe-indicator">
                            <div className="bullets">{bullets}</div>
                        </div>
                    </div>
                    <div className="TruBridge-image" style={bg}>
                        <div className="TruBridge-image-labels">
                            <div className="TruBridge-image-label TruBridge-image-label1 fade-in one">
                                <TranslatedText
                                    tag={currentType.sections[1].label1}
                                />
                            </div>
                            <div className="TruBridge-image-label TruBridge-image-label2 fade-in three">
                                <TranslatedText
                                    tag={currentType.sections[1].label2}
                                />
                            </div>
                            <div className="TruBridge-image-label TruBridge-image-label3 fade-in two">
                                <TranslatedText
                                    tag={currentType.sections[1].label3}
                                />
                            </div>
                        </div>
                    </div>
                    <button
                        onClick={() => history.push(ROUTES.TRUBRIDGE_SIZING)}
                        className="TruBridge-slide-next">
                        <span>Next</span>
                    </button>
                </Fragment>
            );
        }
        return (
            <Hammer onSwipe={swipe}>
                <div className="TruBridgeContainer">
                    <div className="TruBridge-bg" style={style} />
                    <div className="TruBridge-content">
                        <div className="TruBridgeTop">
                            <h3 className="top-title">
                                <TranslatedText tag={currentType.title} />
                            </h3>
                            <h4 className="top-subtitle">
                                <TranslatedText tag={currentType.description} />
                            </h4>
                        </div>

                        {contentBottom}
                    </div>
                </div>
            </Hammer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/trueBridge/TruBridgeTecnology.js